import { useCallback } from 'react';

import { useNotificationPref } from 'hooks/useNotificationPref';
import { SOUND_NOTIFICATIONS_STORAGE_KEY } from 'hooks/useNotificationPref/constants';

import { isAudioSupported } from './utils';

const useTeamChatSoundNotifications = () => {
  const [isEnabled, setEnabled] = useNotificationPref(SOUND_NOTIFICATIONS_STORAGE_KEY);

  const onToggleEnabled = useCallback(() => {
    setEnabled(!isEnabled);
  }, [isEnabled, setEnabled]);

  return {
    isSupported: isAudioSupported(),
    isEnabled,
    onToggleEnabled,
  };
};

export default useTeamChatSoundNotifications;
